export default __webpack_public_path__ + "static/media/NS head Gaeko wire.4611911d.png";